import { StringOptions } from "../../../../components/Select";
import { TransactionType } from "../../../../utils";

export const ALL_VALUE = "";

export const ALL_OPTION: StringOptions = { label: "All", value: ALL_VALUE };

export const PERIOD_MONTH = "month";

export const PERIOD_YEAR = "year";

export const MONTH_CHOICE_OPTIONS: StringOptions[] = [
  { label: "January", value: "1" },
  { label: "February", value: "2" },
  { label: "March", value: "3" },
  { label: "April", value: "4" },
  { label: "May", value: "5" },
  { label: "June", value: "6" },
  { label: "July", value: "7" },
  { label: "August", value: "8" },
  { label: "September", value: "9" },
  { label: "October", value: "10" },
  { label: "November", value: "11" },
  { label: "December", value: "12" },
];

export const TYPE_OPTIONS: StringOptions[] = [
  { label: "All", value: TransactionType.ALL },
  { label: "Income", value: TransactionType.INCOME },
  { label: "Expenses", value: TransactionType.EXPENSE },
  { label: "Transfers", value: TransactionType.TRANSFER },
];

export const ALL_TIME_RANGE: StringOptions = {
  label: "All time",
  value: "all",
};

export const RANGE_OPTIONS: StringOptions[] = [
  ALL_TIME_RANGE,
  { label: "Last 7 days", value: "7d" },
  { label: "Last 30 days", value: "30d" },
  { label: "Last 6 months", value: "6m" },
  { label: "Yearly", value: "year" },
  { label: "Monthly", value: "month" },
];

export const SORT_OPTIONS: StringOptions[] = [
  { label: "Date ↓", value: "date_desc" },
  { label: "Date ↑", value: "date_asc" },
  { label: "Amount ↓", value: "amount_desc" },
  { label: "Amount ↑", value: "amount_asc" },
];
